import React from 'react';
import { FUNDING_MATCH_FIT_TIER_STYLES } from '../../utils/funding/constants';

export const FundingMatchFitTierBadge = ({ tier }) => {
  if (!tier) return null;
  const style = FUNDING_MATCH_FIT_TIER_STYLES[tier] || 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200';
  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${style}`}>
      {tier}
    </span>
  );
};

export default FundingMatchFitTierBadge;
